import * as React from 'react'
import { User, UserInfo } from 'firebase'
const UserContext = React.createContext(null)

export function useCurrentUser(): {
  currentUser: User | UserInfo
  reloadUser: () => Promise<void>
} | null {
  return React.useContext(UserContext)
}

export const UserProvider = UserContext.Provider
